import clsx from 'clsx';
import React from 'react';

interface PillProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  href?: string;
  icon?: string;
  isActive?: boolean;
  onClick?: () => void;
  onClickCapture?: () => void;
  text: string;
}

export default function Pill({
  className,
  text,
  icon,
  isActive = false,
  href,
  onClick,
  onClickCapture,
  ...props
}: PillProps) {
  const pillJSX = (
    <>
      <span className="pill-text">{text}</span>
      {icon && <img src={icon} className="link-icon" />}
    </>
  );

  return href || onClick ? (
    <a
      className={clsx('Pill is-link', { 'is-active': isActive }, className)}
      href={href}
      onClick={onClick}
      onClickCapture={onClickCapture}
      {...props}
    >
      {pillJSX}
    </a>
  ) : (
    <span className={clsx('Pill', className)}>{pillJSX}</span>
  );
}
